import { getFormSyncErrors, getFormValues } from "redux-form";
import { createSelector } from "reselect";

export const getSearchAddressDetails = form =>
  createSelector(getFormValues(form), data => data || {});

export const getSearchAddressErrors = form => state =>
  getFormSyncErrors(form)(state) || {};
